module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step1_Image8b.6306fb98.jpg";